import moment from "moment";
import React, { useEffect, useState } from "react";
import AvailableCalender from "src/Components/MainContent/Appointment/Calendar/AvailableCalender";
import { setLocation, setSlots } from "src/Redux/appSlice";
import { useAppDispatch, useAppSelector } from "src/Redux/hooks";
import { getAvailableOfClass } from "src/Utils/ApiCalls";
import { convertTo12HourFormat } from "src/Utils/Functions";
import { Class, Location, slotDataType, Staff } from "src/Utils/Types";
import PackageAvailableCalender from "./PackageAvailableDates";

const PackageCalenderItem = ({
  classes,
  sendDataToParent,
  index,
  selectedDates,
}: {
  classes: Class;
  sendDataToParent: (data: slotDataType) => void;
  index: number;
  selectedDates: string[];
}) => {
  const [time, setTimes] = useState<
    {
      day: string;
      time: string;
      trainers: Staff[];
      duration: number;
      maxPeople: number;
      people: number;
      locations: Location[];
      _id: string;
    }[]
  >([]);
  const dispatch = useAppDispatch();
  const slots = useAppSelector((state) => state?.app?.slots);
  const [slotData, setSlotData] = useState<slotDataType>({
    date: "",
    classId: classes?._id || "",
    sectionId: (classes?._id || "") + index,
    time: "",
    location: {
      _id: "",
      name: "",
      address: "",
      googleMapLink: "",
      createdAt: "",
    },
    classDuration: 0,
    trainer: {
      email: "",
      name: "",
      phone: "",
      emergencyPhone: "",
      _id: "",
    },
    className: classes?.name || "",
  });
  const [date, setDates] = useState<Date>();
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [locIsOpen, setLocIsOpen] = useState(false);
  const [trainOpen, setTrainIsOpen] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState<Location | null>(
    null
  );
  const [trainers, setTrainers] = useState<Staff[]>([]);
  const [selectedTrainer, setSelectedTrainers] = useState<Staff>();
  const [locationsState, setLocationsState] = useState<Location[]>([]);
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    if (slotData) {
      sendDataToParent(slotData);
    }
  }, [slotData]);

  const isDateDisabled = (date: Date) => {
    const dateStr = date.toISOString();
    return selectedDates.includes(dateStr);
  };

  const getDateClassName = (date: Date) => {
    const dateStr = date.toISOString();
    if (selectedDates.includes(dateStr)) {
      return "disabled-date"; // Add this class to your CSS
    }
    return "";
  };
  const handleLocSelect = (locItem: Location) => {
    setSlotData((prev) => ({
      ...prev,
      location: locItem,
    }));
    setSelectedLocations(locItem);
    dispatch(setLocation(locItem));
    setLocIsOpen(false);
  };
  const handleTrainSelect = (locItem: Staff) => {
    setSlotData((prev) => ({
      ...prev,
      trainer: locItem,
    }));
    setSelectedTrainers(locItem);
    setTrainIsOpen(false);
  };
  const currentDate = moment();
  const tenMinutesFromNow = moment().add(180, "minutes");
  return (
    <div className="mt-3 border border-gray-400 rounded pt-2">
      <PackageAvailableCalender
        enabledDays={classes?.availability?.map((slot) => slot.day) || []}
        sendDate={async (date) => {
          if (isDateDisabled(date)) {
            setMessage("This date is already selected in another slot");
            setTimeout(() => {
              setMessage("");
            }, 2000);
            return;
          }
          setDates(date);
          setTimes([]);
          setSlotData((prev) => ({
            ...prev,
            date: moment(date).toISOString(),
          }));
          const res = await getAvailableOfClass({
            classId: classes?._id || "",
            date: moment(date).format("DD-MM-YYYY"),
          });
          if (res.status! != 200) {
            setMessage(res.message || "Failed to fetch available slots");
            setTimeout(() => {
              setMessage("");
            }, 2000);
            return;
          }
          setTimes(res?.data?.slots);
          if (
            res.data?.slots?.length > 0 &&
            res.data?.slots[0]?.people <= res.data?.slots[0]?.maxPeople
          ) {
            setSlotData((prev) => ({
              ...prev,
              location: res.data?.slots[0]?.locations[0],
              trainer: res.data?.slots[0]?.trainers[0],
            }));
            setLocationsState(res.data?.slots[0]?.locations);
            setTrainers(res.data?.slots[0]?.trainers);
            setSelectedLocations(res?.data?.slots[0]?.locations[0]);
            setSelectedTrainers(res?.data?.slots[0]?.trainers[0]);
            // setSelectedTime(res.data?.slots[0]?.time);
          }
        }}
        selectedDates={selectedDates}
      />
      <div
        className="px-5"
        style={{
          marginTop: "1rem",
          background: "#1f0e4e14",
          paddingBottom: "1rem",
        }}
      >
        {time?.filter((slot) => {
          // Skip if not today
          if (!moment(date).isSame(currentDate, "day")) {
            return true;
          }

          // For today, only show times at least 10 minutes in the future
          const slotTime = moment(slot.time, "HH:mm");
          return slotTime.isAfter(tenMinutesFromNow);
        })?.length > 0 && (
          <div className=" py-3 mb-5">
            <h3 className="mb-2 fs-12" style={{ fontSize: "14px" }}>
              {moment(date).format("MMMM DD, YYYY") +
                " " +
                convertTo12HourFormat(selectedTime || time[0].time)}
            </h3>
            <div className="grid gap-1 grid-cols-2">
              {time
                ?.filter((slot) => {
                  // Skip if not today
                  if (!moment(date).isSame(currentDate, "day")) {
                    return true;
                  }

                  // For today, only show times at least 10 minutes in the future
                  const slotTime = moment(slot.time, "HH:mm");
                  return slotTime.isAfter(tenMinutesFromNow);
                })
                .map((t, i) => {
                  return (
                    <button
                      key={i}
                      className={`rounded py-2 br-2 align-center${
                        selectedTime === t?.time
                          ? " time-button text-white"
                          : " border-solid border-2 border-blue-900  text-black"
                      }`}
                      style={{
                        cursor:
                          t?.people >= t?.maxPeople ? "not-allowed" : "pointer",
                      }}
                      disabled={t?.people >= t?.maxPeople}
                      onClick={() => {
                        setSlotData((prev) => ({
                          ...prev,
                          time: t?.time,
                          duration: t?.duration,
                        }));
                        setLocationsState(t?.locations);
                        setSelectedLocations(t?.locations[0]);
                        setSelectedTrainers(t?.trainers[0]);
                        setSelectedTime(t?.time);
                      }}
                    >
                      {t.people > t?.maxPeople
                        ? "Fulley Booked"
                        : convertTo12HourFormat(t?.time) +
                          "\n" +
                          t?.people +
                          "/" +
                          t?.maxPeople}
                    </button>
                  );
                })}
            </div>
          </div>
        )}
        {selectedTime && (
          <div className="flex gap-2">
            <div className="select-wrapper">
              <p style={{ marginBottom: ".4rem" }}>Location</p>
              <button
                onClick={() => {
                  setLocIsOpen(!locIsOpen);
                }}
                className="select-button"
              >
                <span>
                  {selectedLocations
                    ? selectedLocations.name
                    : "Select Location"}
                </span>
                <span className={`arrow ${locIsOpen ? "open" : ""}`}>▼</span>
              </button>
              {locIsOpen && (
                <div className="dropdown-container">
                  <div className="dropdown-content">
                    <div className="categories-list-loc">
                      {locationsState?.map((category) => {
                        return (
                          <div
                            key={category._id}
                            className="category-item"
                            onClick={() => handleLocSelect(category)}
                            // onMouseLeave={() => setHoveredCategoryId(null)}
                          >
                            <div className="category-title">
                              {category?.name}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* <div className="select-wrapper">
              <p style={{ marginBottom: ".4rem" }}>Trainer</p>
              <button
                onClick={() => {
                  setTrainIsOpen(!trainOpen);
                }}
                className="select-button"
              >
                <span>
                  {selectedTrainer ? selectedTrainer.name : "Select Trainer"}
                </span>
                <span className={`arrow ${trainOpen ? "open" : ""}`}>▼</span>
              </button>
              {trainOpen && (
                <div className="dropdown-container">
                  <div className="dropdown-content">
                    <div className="categories-list-loc">
                      {trainers?.map((category) => {
                        return (
                          <div
                            key={category._id}
                            className="category-item"
                            onClick={() => handleTrainSelect(category)}
                            // onMouseLeave={() => setHoveredCategoryId(null)}
                          >
                            <div className="category-title">
                              {category?.name}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default PackageCalenderItem;
